module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_reflexni-cervena.b58b7e81.png";